import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { useAuth } from '@/hooks/use-auth'
import { getCompanies } from '@/services/get-companies'
import { AsyncReturnType } from '@/types/utils'

export const GET_COMPANIES_BY_USER_QUERY = 'companies-by-user'

export const useGetCompanies = (options: {
  enabled?: boolean
  onSuccess?: (data: AsyncReturnType<typeof getCompanies>) => void
}) => {
  const { user } = useAuth()

  const cacheTime = useMemo(
    () => (options.enabled ? undefined : 0),
    [options.enabled],
  )

  const query = useQuery({
    queryKey: [GET_COMPANIES_BY_USER_QUERY, { user: user.id }],
    queryFn: ({ signal }) => getCompanies(user.id, { signal }),
    cacheTime,
    ...options,
  })

  return query
}
